import { TextField, Typography } from '@material-ui/core'
import React from 'react'
import { PieChart, ProgressBar, StatsList } from '../charts'
import { demoStats, generatePieChartData } from '../charts/__testing__'
import { Loader, Tag, Timestamp } from '../decorative'
import { ButtonMenu } from '../layout'
import { FormSection } from '../forms'
import { DraggableLayoutDemo } from './DraggableLayoutDemo'

const date = Date.now()

export const ChartsSection = () => {
  return <FormSection title="Chart Components">
    <ProgressBar percentage={50} title="Bar 1" />
    <ProgressBar percentage={80} title="Bar 2" />
    <ProgressBar percentage={90} title="Bar 2" />

    <h3>Lists of Stats</h3>
    <StatsList items={demoStats.slice(0,2)} />
    <StatsList items={demoStats} />

    <h3>Pie Chart</h3>
    <PieChart data={generatePieChartData(1)} />
  </FormSection>
}

export const DecorativeSection = () => {
  return <FormSection title="Decorative Components">
    <Loader />
    <br />
    <Tag title="A Tag" />
    <Tag title="Another Tag" />
    <p>Loaded: <Timestamp date={date} /></p>
  </FormSection>
}

export const DraggableSection = () => {
  return <FormSection title="Draggable Component">
    <DraggableLayoutDemo />
  </FormSection>
}

export const LayoutSection = () => {
  return <FormSection title="Layout Components">
    <ButtonMenu label="Click to open a form">
      <Typography>This could contain a full form if you wanted!</Typography>
      <TextField variant="outlined" />
      <ProgressBar percentage={20} title="Bar 1" />
      <ProgressBar percentage={60} title="Bar 2" />
      <ProgressBar percentage={70} title="Bar 2" />
    </ButtonMenu>
  </FormSection>
}
